import Column from '@components/Column';
import Indicator from '@components/Indicator';
import Row from '@components/Row';
import styled from '@emotion/styled';
import useScrollIndicator from '@hooks/ui/useScrollIndicator';

import AllButton from './AllButton';
import MyMenu from './MyMenu';
import PickButton from './PickButton';
import useScrollEnd from './useScrollEnd';

function MyMenus() {
    const { isScrolling, onScroll: onScrollWithEnd } = useScrollEnd({ id: 'my-menus' });
    const { onScroll, current } = useScrollIndicator({ totalCount: 10, padding: 30 });
    return (
        <Column align='center'>
            <Container spacing={4}
                id='my-menus'
                onScroll={(e) => {
                    onScrollWithEnd();
                    onScroll(e);
                }}
                fullWidth >
                <PickButton isScrolling={isScrolling}/>
                {Array.from({ length: 10 }, (_, i) => (
                    <MyMenu key={`myMenu${i}`}/>
                ))}
                <AllButton/>
            </Container>
            <Indicator total={10} current={current} />
        </Column>);
}

const Container = styled(Row)`
    overflow-y: auto;
    padding: 10px 20px 22px;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export default MyMenus;
